module.exports = __webpack_public_path__ + "1b0a107021019235432e8dc367eb46f6.svg";